import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import "./PageManager.css";
import UKFlag from './UKFlag.png';
import GeoFlag from './geoflag.svg';
import * as yup from 'yup';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import PageDeleter from "./PageDeleter";
import JoditEditor from "jodit-react";
import {Checkbox, FormControlLabel} from "@mui/material";


const formSchema = yup.object().shape({
    name: yup.string().required('აუცილებელი ველი'),
    nameEng: yup.string().required('აუცილებელი ველი'),
    description: yup.string().test(
        'is-empty',
        'Description is required',
        value => value && value.replace(/<(.|\n)*?>/g, '').trim() !== ''
    ),
    descriptionEng: yup.string().test(
        'is-empty',
        'Description (English) is required',
        value => value && value.replace(/<(.|\n)*?>/g, '').trim() !== ''
    ),
    url: yup.string().required('აუცილებელი ველი'),
    sort: yup.number().required('აუცილებელი ველი').positive("არასწორი ფორმატი").integer("არასწორი ფორმატი"),
    groupName: yup.string().required('აუცილებელი ველი'),
    groupNameEng: yup.string().required('Group Name (English) is required')

});
const PageManager = () => {
    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [nameEng, setNameEng] = useState('');
    const [description, setDescription] = useState('');
    const [descriptionEng, setDescriptionEng] = useState('');
    const [isTemplate, setIsTemplate] = useState(false);
    const [url, setUrl] = useState('');
    const [sort, setSort] = useState(0);
    const [groupName, setGroupName] = useState('')
    const [groupNameEng, setGroupNameEng] = useState(''); // New state variable;
    const [errors, setErrors] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const alertTimeout = useRef(null);
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const [data, setData] = useState([]);
    const [selectedValue, setSelectedValue] = useState("");

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllPageFooter`)
            .then(response => {
                if (response.data && response.data.data) {
                    setData(response.data.data);
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    const georgianTranslations = {
        "Type something": " ",
        "Bold": "ტექსტის გამუქება",
        "Italic": "დახრილი ტექსტის შექმნა",
        "Underline": "ტექსტის ხაზგასმა",
        "Insert Image": "სურათის ჩასმა",
        "Clear Formatting": "ფორმატირების წაშლა",
        "Insert Format Block": "ფორმატირების ბლოკის ჩასმა",
        "Strike through": "გადახაზული",
        "Insert Unordered List": "ბურთულებიანი სიის შექმნა",
        "Insert Ordered List": "დანომრილი სიის შექმნა",
        "Font family": "შრიფტის არჩევა",
        "Font size": "შრიფტის ზომა",
        "Line height": "ხაზის დაშორება",
        "Insert Horizontal Line": "ხაზის დაშორება",
        "Increase Indent": "დაშორების გაზრდა",
        "Decrease Indent": "დაშორების შემცირება",
        "Undo": "უკუსვლა",
        "Redo": "საწყისი",
        "Align": "სწორება",
        "Insert Special Character": "სპეც. სიმბოლო",
        "Fill color or set the text color": "ფერის შეცვლა",
        "Background": "ფონი",
        "Text": "ტექსტი",
        "Insert format block": "ფორმატირება",
        "Print": "დაბეჭვდა",
        "Show all": "მეტის ნახვა",
        "Class name": "კლასის სახელი",
        "Open in new tab": "ახალ გვერდზე გახსნა",
        "Insert": "დამატება",
        "URL": "ბმული",
        "Insert link": "ბმლის ჩასმა",

    };

    const config = {
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        height: 800,
        width: 650,
        noFollowCheckbox: false,
        disablePlugins: [
            'table',
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            },

        },
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', 'link', '|',
            'font', 'fontsize', 'brush', 'paragraph', '|',
            'image', 'table', '|',
            'align', 'undo', 'redo', '|',
            'hr', 'eraser', 'copyformat', '|',
            'symbol', 'fullsize', 'print', 'about'
        ],
    };
    const handlePageChange = (pageId, pageUrl) => {
        setSelectedValue(pageUrl)
        if (pageUrl !== '') {

            axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllPageByUrl?Url=${pageUrl}`)
                .then(response => {
                    if (response.data && response.data.data) {
                        setDescription(response.data.data.description);
                        setDescriptionEng(response.data.data.descriptionEng);

                        setId(response.data.data.id)
                        setName(response.data.data.name)
                        setNameEng(response.data.data.nameEng)
                        setUrl(response.data.data.url)
                        setSort(response.data.data.sort)
                        setGroupName(response.data.data.groupName)
                        setGroupNameEng(response.data.data.groupNameEng)
                        setIsTemplate(response.data.data.isTemplate)
                    }
                }).catch(error => console.error('Error fetching data:', error));
        } else {
            clearData()
        }
    };
    const clearData = () => {
        setId('');
        setName('');
        setNameEng('');
        setDescription('');
        setDescriptionEng('');
        setUrl('');
        setSort(0);
        setGroupName('');
        setGroupNameEng('');
        setSelectedValue('')
    };

    // Function to validate data
    const validate = async (data) => {
        try {
            await formSchema.validate(data, {abortEarly: false});
            return {}; // Return empty object if validation is successful
        } catch (err) {
            return err.inner.reduce((acc, currentError) => {
                acc[currentError.path] = currentError.message;
                return acc;
            }, {});
        }
    };


    useEffect(() => {
        void validate({name, nameEng, description, descriptionEng, url, sort, groupName});
    }, [name, nameEng, description, descriptionEng, url, sort, groupName]);

    const handleSubmit = async () => {
        const payload = {name, nameEng, description, descriptionEng, url, sort, groupName, groupNameEng};
        const newErrors = await validate(payload);

        setErrors(newErrors); // Update the errors state

        if (Object.keys(newErrors).length === 0) {
            setIsModalOpen(true); // Open the modal instead of sending data
        } else {
        }
    };


    const handleModalConfirm = async () => {
        setIsModalOpen(false);
        if (selectedValue === "") { // ემატება ახალი
            const payload = {name, nameEng, description, descriptionEng, url, sort, groupName, groupNameEng, isTemplate};
            const jwtToken = localStorage.getItem('jwtToken');

            try {
                await fetch(`${process.env.REACT_APP_API_BASE_URL}/AddNewPage`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${jwtToken}`
                    },
                    body: JSON.stringify(payload),
                });


                clearData();
                setAlert({show: true, message: 'გვერდი დაემატა წარმატებით', type: 'success'});
                alertTimeout.current = setTimeout(() => setAlert({show: false, message: '', type: ''}), 5000);
                setUpdateTrigger(prev => prev + 1); // Increment the trigger


            } catch (error) {
                setAlert({show: true, message: 'დაფიქსირდა შეცდომა!', type: 'error'});
                alertTimeout.current = setTimeout(() => setAlert({show: false, message: '', type: ''}), 5000);
            }
        } else { //რედაქტირების დროს
            const payload = {id, name, nameEng, description, descriptionEng, url, sort, groupName, groupNameEng, isTemplate};
            const jwtToken = localStorage.getItem('jwtToken');

            try {
                await fetch(`${process.env.REACT_APP_API_BASE_URL}/UpdatePage`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${jwtToken}`
                    },
                    body: JSON.stringify(payload),
                });


                clearData();
                setSelectedValue('')
                setAlert({show: true, message: 'გვერდი განახლდა წარმატებით', type: 'success'});
                alertTimeout.current = setTimeout(() => setAlert({show: false, message: '', type: ''}), 5000);
                setUpdateTrigger(prev => prev + 1); // Increment the trigger


            } catch (error) {
                console.error('Error:', error);
                setAlert({show: true, message: 'დაფიქსირდა შეცდომა!', type: 'error'});
                alertTimeout.current = setTimeout(() => setAlert({show: false, message: '', type: ''}), 5000);
            }
        }
    };


    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllPageFooter`)
            .then(response => {
                if (response.data && response.data.data) {
                    setData(response.data.data);
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }, [updateTrigger]);

    useEffect(() => {
        return () => clearTimeout(alertTimeout.current);
    }, []);


    return (
        <div className={"page-manager-page-mainwrappper"}>
            <div className="page-manager-page">
                <div className="page-manager-container">
                    <select
                        id="page-selector-dropdown"
                        className="page-deleter-dropdown"
                        onChange={(e) => handlePageChange(e.target.key, e.target.value)}
                        value={selectedValue}>
                        <option value="">აირჩიეთ გვერდი</option>
                        {data.map(item => (
                            <option key={item.id} value={item.url}>{item.name}</option>
                        ))}
                    </select>
                    <h1 className="page-manager-title">გვერდების მენეჯერი</h1>
                    <div className="page-manager-editor-container">
                        <div className="page-manager-editor">
                            <div className="page-manager-input-with-flag">
                                <input className="page-manager-input" placeholder="სათაური" value={name}
                                       onChange={e => setName(e.target.value)}/>
                                <img src={GeoFlag} alt="Geo Flag" className="input-flag"/>
                            </div>
                            {errors.name && <p className="a">{errors.name}</p>}

                            <JoditEditor
                                value={description}
                                config={config}
                                tabIndex={1}
                                onBlur={newContent => setDescription(newContent)}
                                style={{width: '800px', height: '400px'}}
                            />
                            {errors.description && <p className="error-message">{errors.description}</p>}

                        </div>
                        <div className="page-manager-editor">
                            <div className="page-manager-input-with-flag">
                                <input className="page-manager-input" placeholder="სათაური (ინგლისურად)" value={nameEng}
                                       onChange={e => setNameEng(e.target.value)}/>
                                <img src={UKFlag} alt="UK Flag" className="input-flag"/>
                            </div>
                            {errors.nameEng && <p className="a">{errors.nameEng}</p>}

                            <JoditEditor
                                value={descriptionEng}
                                config={config}
                                tabIndex={1}
                                onBlur={newContent => setDescriptionEng(newContent)}
                                style={{width: '800px', height: '400px'}}
                            />
                            {errors.descriptionEng && <p className="error-message">{errors.descriptionEng}</p>}

                        </div>
                    </div>
                    <FormControlLabel
                        style={{marginRight: 70}}
                        control={<Checkbox checked={isTemplate}
                                           onChange={(e) => {
                                               setIsTemplate(e.target.checked);
                                           }}/>}
                        label="შაბლონად შენახვა"
                    />
                    <div className="page-manager-input-group">
                        <input className="page-manager-input" placeholder="ბმული" value={url}
                               onChange={e => setUrl(e.target.value)}/>
                        {errors.url && <p className="a">{errors.url}</p>}
                        <input className="page-manager-input" placeholder="სორტირება" value={sort}
                               onChange={e => setSort(Number(e.target.value))}/>
                        {errors.sort && <p className="a">{errors.sort}</p>}
                        <input className="page-manager-input" placeholder="ჯგუფის სახელი" value={groupName}
                               onChange={e => setGroupName(e.target.value)}/>
                        {errors.groupName && <p className="a">{errors.groupName}</p>}
                        <input className="page-manager-input" placeholder="ჯგუფის სახელი (ინგლსურად)"
                               value={groupNameEng} onChange={e => setGroupNameEng(e.target.value)}/>
                        {errors.groupNameEng && <p className="error-message">{errors.groupNameEng}</p>}
                    </div>
                    <div className="page-manager-actions">
                        <button className="page-manager-submit-button" onClick={handleSubmit}>გაგზავნა</button>
                        <button className="page-manager-clear-button" onClick={clearData}>გასუფთავება</button>
                    </div>
                    <h1 className="page-manager-title">გვერდის წაშლა</h1>

                    <PageDeleter/>


                </div>
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onConfirm={handleModalConfirm}
                />
                {alert.show && (
                    <div className={`custom-alert ${alert.type} show`}>
                        {alert.message}
                    </div>
                )}


            </div>
        </div>
    );
};

export default PageManager;
